/**
 * Flight category determination from visibility and ceiling.
 */
import type { FlightCategory } from '../types';

export function determineFlightCategory(
  visibilitySM: number,
  ceilingFt: number | null,
): FlightCategory {
  const vis = visibilitySM;
  const ceil = ceilingFt ?? Infinity;

  if (vis < 1 || ceil < 500) return 'LIFR';
  if (vis < 3 || ceil < 1000) return 'IFR';
  if (vis <= 5 || ceil <= 3000) return 'MVFR';
  return 'VFR';
}
